// components/Navigation/UKEntitySelector/QuickSelectClubs.js
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Button, Modal } from 'react-bootstrap';
import { toggleClub, clearSelections } from '../../../../redux/slices/myGymTV/ukEntitiesSlice';
import './quick-select-clubs.scss';

const QuickSelectClubs = () => {
    const dispatch = useDispatch();
    const { ukEntityData } = useSelector((state) => state.user);
    const [inputValue, setInputValue] = useState('');
    const [showInput, setShowInput] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState({ notFound: [], selected: 0 });

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!inputValue.trim()) return;

        // Parse and sanitize the input
        const inputIds = inputValue
            .split(',')
            .map(id => id.trim())
            .filter(id => id !== '')
            .map(id => parseInt(id, 10))
            .filter(id => !isNaN(id));

        if (inputIds.length === 0) {
            setModalData({
                notFound: ['Invalid input - please enter numeric club IDs'],
                selected: 0
            });
            setShowModal(true);
            return;
        }

        // Find matching clubs from available entities
        const foundClubs = [];
        const notFoundIds = [];

        inputIds.forEach(clubId => {
            const club = ukEntityData.find(entity => entity.ClubId === clubId);
            if (club) {
                foundClubs.push(club);
            } else {
                notFoundIds.push(clubId);
            }
        });

        // Select all found clubs
        foundClubs.forEach(club => {
            dispatch(toggleClub(club));
        });

        // Show results
        if (notFoundIds.length > 0 || foundClubs.length > 0) {
            setModalData({
                notFound: notFoundIds,
                selected: foundClubs.length
            });
            setShowModal(true);
        }

        // Switch to button mode
        setShowInput(false);
    };

    const handleClear = () => {
        setInputValue('');
        setShowInput(true);
        dispatch(clearSelections());
    };

    const handleAddMore = () => {
        setInputValue('');
        setShowInput(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    if (!showInput) {
        return (
            <div className="quick-select-clubs mb-3">
                <div className="button-group d-flex gap-2">
                    <Button
                        className="flex-fill"
                        onClick={handleClear}
                        size="sm"
                        variant="outline-light"
                    >
                        Clear
                    </Button>
                    <Button
                        className="flex-fill"
                        onClick={handleAddMore}
                        size="sm"
                        variant="outline-light"
                    >
                        Add More
                    </Button>
                </div>

                <Modal
                    centered
                    onHide={handleCloseModal}
                    show={showModal}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Quick Select Results</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {modalData.selected > 0 && (
                            <div className="mb-3">
                                <p className="text-success mb-0">
                                    ✓ {modalData.selected} venue{modalData.selected !== 1 ? 's' : ''} selected
                                </p>
                            </div>
                        )}
                        {modalData.notFound.length > 0 && (
                            <div>
                                <p className="text-warning mb-2">
                                    The following ID(s) were not found:
                                </p>
                                <ul className="mb-0">
                                    {modalData.notFound.map((id, index) => (
                                        <li key={index}>{id}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            onClick={handleCloseModal}
                            variant="primary"
                        >
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }

    return (
        <div className="quick-select-clubs mb-3">
            <Form onSubmit={handleSubmit}>
                <Form.Group>
                    <Form.Label className="text-white small mb-1">
                        Quick Select
                    </Form.Label>
                    <Form.Control
                        onChange={(e) => setInputValue(e.target.value)}
                        placeholder="e.g. 28536, 28537..."
                        size="sm"
                        type="text"
                        value={inputValue}
                    />
                </Form.Group>
                <Button
                    className="mt-2 w-100"
                    disabled={!inputValue.trim()}
                    size="sm"
                    type="submit"
                    variant="primary"
                >
                    Select Clubs
                </Button>
            </Form>

            <Modal
                centered
                onHide={handleCloseModal}
                show={showModal}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Quick Select Results</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {modalData.selected > 0 && (
                        <div className="mb-3">
                            <p className="text-success mb-0">
                                ✓ {modalData.selected} venue{modalData.selected !== 1 ? 's' : ''} selected
                            </p>
                        </div>
                    )}
                    {modalData.notFound.length > 0 && (
                        <div>
                            <p className="text-warning mb-2">
                                The following ID(s) were not found:
                            </p>
                            <ul className="mb-0">
                                {modalData.notFound.map((id, index) => (
                                    <li key={index}>{id}</li>
                                ))}
                            </ul>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={handleCloseModal}
                        variant="primary"
                    >
                        OK
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default QuickSelectClubs;